import maintenanceNotificationHub from "../../api/hubs/maintenanceNotificationHub";
import maintenanceApi from "../../api/maintenance";
import { formatDate } from "../../utils/dateTimeFormatter"

export default {
    state:{
        maintenanceFrom: new Date(0),
        maintenanceTill: new Date(0),
        isPlanned: false,
        isInProgress: false
    },
    actions: {
        async startMaintenanceNotificationMonitoring(store) {
            var handlers = {
                maintenance: (data) => {
                    _addMaintenance(data, store);
                }
            }
            await maintenanceNotificationHub.startConnection(handlers);
        },
        async stopMaintenanceNotificationMonitoring() {
            await maintenanceNotificationHub.stopConnection();
        },
        async getMaintenanceInfo(store){
            var data = await maintenanceApi.getPlannedMaintenance();
            _addMaintenance(data, store)
        }
    },
    mutations: {
        setMaintenanceState: (state, data) => {
            state.maintenanceFrom = data.From,
            state.maintenanceTill = data.Till,
            state.isPlanned = data.IsPlanned,
            state.isInProgress = data.IsInProgress
        } 
    },
    getters: {
        maintenanceMessage: (state, getters) => () => {
            let from = formatDate(state.maintenanceFrom, "MM/DD/YYYY hh:mm a")
            let till = formatDate(state.maintenanceTill, "MM/DD/YYYY hh:mm a (z)");

            let msg;
            if (getters.isAuthorized) {
                msg = state.isInProgress
                    ? `CMS On Test application is under maintenance. Planned end time is ${till}`
                    : `CMS On Test application is going to be updated between ${from} and ${till}`;
            } else {
                msg = state.isInProgress
                    ? `Application is under maintenance. Planned end time is ${till}`
                    : `MAINTENANCE NOTIFICATION - Application is going to be updated between ${from} and ${till}`;
            }
    
            return msg;
        },
        maintenanceType: (state) => state.isInProgress ? "error" : "info"
    }
}

function _addMaintenance(data, { state, commit, getters }){

    commit('setMaintenanceState', data);

    if(!state.isPlanned){
        return;
    }

    const id = "maintenanceNotification"

    if(!getters.notyExists(id)){
        let noty = {
            id: id,
            typeFunc: "maintenanceType",
            func: "maintenanceMessage"
        };
    
        commit('addNoty', noty);
    }
}